/**
 * Normalize a string for search comparison: lowercase, without diacritics (accents).
 * Use for accent-insensitive and case-insensitive matching.
 * @param {string} str - String to normalize
 * @returns {string} Normalized string (empty string if input is falsy)
 */
export function normalizeStringForSearch(str) {
  if (str == null || typeof str !== 'string') return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/**
 * Check if haystack contains needle, ignoring case and accents.
 * @param {string} haystack - String to search in
 * @param {string} needle - String to search for
 * @returns {boolean} True if haystack contains needle (accent and case insensitive)
 */
export function stringIncludesInsensitiveAccents(haystack, needle) {
  if (needle == null || (typeof needle === 'string' && !needle)) return true;
  if (haystack == null || typeof haystack !== 'string') return false;
  const normalizedHaystack = normalizeStringForSearch(haystack);
  const normalizedNeedle = normalizeStringForSearch(needle);
  return normalizedHaystack.includes(normalizedNeedle);
}
